import constants from '@/helpers/constants';
import utilities from '@/helpers/utilities';
import Person from './Person';


export default {
    build(person) {
        return {
            id: 0,
            code: 0,
            owner: Object.assign({ id: null }, person),
            creator: Object.assign({ id: null }, person),
            requester: Object.assign({ id: null }, person),
            status: { id: null },
            system: { id: null },
            type: { id: null },
            contract: { id: null },
            contractItem: { id: null },
            relatedDemand: { id: null },
            title: '',
            description: '',
            remarks: '',
            reason: '',
            outcome: '',
            similarDemandsDescription: '',
            filesDescription: '',
            files: [],
            lastFlowDate: '',
            desirableDate: '',
            inWarranty: false,
            warrantyUntil: '',
            subOwners: [],
            ownerType: 0,
        };
    },

    copy(demand) {
        demand = demand || this.build();
        const fileList = utilities.acumulateFiles(demand.workflowHistory, constants.STATUS_CREATED);
        utilities.acumulateFiles(demand.workflowHistory, constants.STATUS_REJECTED)
            .forEach((item) => {
                fileList.push(item);
            });
        return {
            id: demand.id,
            code: demand.code,
            owner: Person.toForm(demand.owner),
            creator: Person.toForm(demand.creator),
            requester: Person.toForm(demand.requester),
            status: { id: demand.status.id },
            system: { id: demand.system.id },
            type: { id: demand.type.id },
            contract: { id: demand.contract.id },
            contractItem: { id: (demand.contractItem || {}).id },
            relatedDemand: { id: (demand.relatedDemand || {}).id },
            title: demand.title,
            description: demand.description,
            remarks: demand.remarks,
            reason: demand.reason,
            outcome: demand.outcome,
            similarDemandsDescription: demand.similarDemandsDescription,
            filesDescription: demand.filesDescription,
            lastFlowDate: demand.lastFlowDate,
            files: fileList,
            removedFiles: [],
            desirableDate: demand.desirableDate,
            inWarranty: demand.inWarranty,
            warrantyUntil: demand.warrantyUntil,
            subOwners: demand.subOwners,
            ownerType: demand.ownerType,
            office: {id: 0, controlEvaluation: false},
            scoreAverage: demand.scoreAverage,
            allowedEvaluationSupplier: false,

            estimatedDeliveryDate: demand.estimatedDeliveryDate,
            maximumApprovalDeliveryDate: demand.maximumApprovalDeliveryDate
        };
    },

    prepare(demand) {
        const copy = this.copy(demand);

        copy.files = demand.files.filter(e => e.isNewFile === true);
        copy.removedFiles = demand.removedFiles;

        if (utilities.isEmptyOrZero(copy.relatedDemand.id)) copy.relatedDemand = null;

        return copy;
    },

    approval: {
        build() {
            return {
                id: 0,
                code: '',
                comments: '',
                files: [],
                removedFiles: [],
            };
        },

        copy({ id, code }) {
            return {
                id,
                code,
                comments: '',
                files: [],
                removedFiles: [],
            };
        },
    },

    cancel: {
        build() {
            return {
                id: 0,
                code: '',
                comments: '',
                files: [],
                removedFiles: [],
            };
        },

        copy({ id, code }) {
            return {
                id,
                code,
                comments: '',
                files: [],
                removedFiles: [],
            };
        },
    },

    delivery: {
        build() {
            return {
                id: 0,
                deliverableId: 0,
                plannedTime: '',
                deliveryDate: null,
                executedTime: '',
                description: '',
                files: [],
                removedFiles: [],
            };
        },

        copy(demand) {
            const delivery = demand.deliveries[0] || this.build();

            return {
                id: demand.id,
                code: demand.code,
                deliverableId: delivery.id,
                plannedTime: delivery.plannedTime,
                deliveryDate: delivery.deliveryDate,
                executedTime: delivery.executedTime,
                description: delivery.description,
                files: utilities.acumulateFiles(
                    demand.workflowHistory,
                    constants.STATUS_DELIVERY,
                ),
                removedFiles: [],
            };
        },

        prepare(delivery) {
            const copy = Object.assign({}, delivery);

            copy.plannedTime = delivery.plannedTime.toString().replace(',', '.');
            copy.removedFiles = delivery.removedFiles;
            copy.files = delivery.files.filter(e => e.isNewFile === true);

            return copy;
        },
    },

    planning: {
        build() {
            return {
                id: 0,
                estimatedTime: '',
                daysToDelivery: null,
                description: '',
                files: [],
                removedFiles: [],
            };
        },

        copy(demand) {
            if (demand.estimatedTime === undefined) demand.estimatedTime = '';

            return {
                id: demand.id,
                code: demand.code,
                estimatedTime: demand.estimatedTime.toString(), // #TODO: fix this shit
                daysToDelivery: demand.daysToDelivery,
                description: demand.planningDescription,
                estimatedDeliveryDate: demand.estimatedDeliveryDate,
                maximumApprovalDeliveryDate: demand.maximumApprovalDeliveryDate,

                files: utilities.acumulateFiles(
                    demand.workflowHistory,
                    constants.STATUS_PLANNING,
                ),
            };
        },

        prepare(planning) {
            const copy = this.copy(planning);

            copy.files = planning.files.filter(e => e.isNewFile === true);
            copy.description = planning.description;
            copy.removedFiles = planning.removedFiles;
            copy.estimatedTime = planning.estimatedTime.toString().replace(',', '.');

            return copy;
        },
    },
};



// WEBPACK FOOTER //
// ./src/helpers/entities/Demand.js